import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Button } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
import { getArrayElement, isObject } from '../lib/walk-schema.js';
import { RenderSchema } from '../render-schema.js';
import { ZodField } from '../zod-field.js';
export function RepeaterWidget(props) {
    const { field, fieldState, meta, schema, label, description, hint, name } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ctx = useFormContext();
    const arrName = name ?? field.name;
    const arr = useFieldArray({ control: ctx.control, name: arrName });
    const element = getArrayElement(schema);
    // Подписи кнопок и строк — из meta (`addLabel`/`removeLabel`/`itemLabel`):
    // русским формам нужен русский текст; без meta — прежние подписи.
    const addLabel = typeof meta.addLabel === 'string' ? meta.addLabel : 'Add';
    const removeLabel = typeof meta.removeLabel === 'string' ? meta.removeLabel : 'Remove';
    const itemLabel = typeof meta.itemLabel === 'string' ? meta.itemLabel : '#';
    // Ошибка всего списка («нужно хотя бы два») react-hook-form кладёт у массива
    // полей в `root`, а не в `message` — без этого она не показывалась вовсе.
    const err = fieldState.error;
    const listMessage = err?.message ?? err?.root?.message;
    const shellState = listMessage !== undefined && err?.message === undefined
        ? { ...fieldState, error: { type: 'custom', message: listMessage } }
        : fieldState;
    return (_jsx(FieldShell, { meta: meta, fieldState: shellState, label: label, description: description, hint: hint, htmlFor: arrName, children: _jsxs("div", { className: "flex flex-col gap-2", children: [arr.fields.map((row, idx) => {
                    const rowName = `${arrName}.${idx}`;
                    return (_jsxs("div", { className: "flex flex-col gap-2 rounded-[var(--radius-2)] border border-[var(--color-border-subtle)] p-3", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("span", { className: "text-xs font-medium text-[var(--color-text-muted)]", children: itemLabel === '#' ? `#${idx + 1}` : `${itemLabel} ${idx + 1}` }), _jsx(Button, { type: "button", variant: "ghost", size: "sm", onClick: () => arr.remove(idx), children: removeLabel })] }), element && isObject(element) ? (_jsx(RenderSchema, { schema: element, prefix: rowName })) : (_jsx(ZodField, { name: rowName }))] }, row.id));
                }), _jsx(Button, { type: "button", variant: "secondary", size: "sm", onClick: () => arr.append(defaultFor(element)), children: addLabel })] }) }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function defaultFor(schema) {
    if (!schema)
        return {};
    if (isObject(schema))
        return {};
    return '';
}
//# sourceMappingURL=repeater.js.map